import {
  NeedsCategoryDto,
  NeedsDomainDto,
} from '@act/shared/data-transfer-objects';
import { ColumnConfiguration } from '@act/storybook';

export const NeedsCategoriesTableColumns = (
  domains: NeedsDomainDto[]
): ColumnConfiguration<NeedsCategoryDto>[] => [
  {
    id: 'label',
    value: 'label',
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Category Label',
  },
  {
    id: 'key',
    value: 'key',
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Key',
  },
  {
    id: 'domainId',
    value: (row: NeedsCategoryDto) => {
      const domain = domains.find(d => d.id === row.domainId);
      return domain?.label;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    title: 'Domain',
  },
];
